<template>
    <div>
        <v-layout align-center pa-0>
            <v-flex>
                <v-text-field :data-testid="$options.name + 'v-text-field' + 'date.masked'"
                    ref="inputMask"
                    light
                    color="secondary"
                    v-model="date.masked"
                    return-masked-value
                    mask="##:##"
                    outline
                    :placeholder="defaultValue"
                    :label="$t('time')"
                    @change="(payload) => date.raw = payload"
                    @click:clear="() => date.raw = ''"
                    @input="onInput($event)"
                    @blur="onBlur"
                ></v-text-field>
            </v-flex>
        </v-layout>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'

// Типы
type TimeValue = string | Date

interface DateState {
  raw: string
  formatted: string
  masked: string
}

interface InputState {
  mask: boolean
  disabled: boolean
  error: boolean
}

interface StateMessages {
  error: string[]
}

interface StateData {
  messages: StateMessages
}

interface ComponentData {
  shown: boolean
  date: DateState
  input: InputState
  state: StateData
}

export default Vue.extend({
  name: 'TIME_SELECTOR',

  props: {
    value: {
      type: [String, Date] as Vue.PropType<TimeValue>,
      default: ''
    },
    name: {
      type: String,
      default: 'date'
    },
    min: {
      type: [String, Date] as Vue.PropType<TimeValue | null>,
      default: null
    },
    max: {
      type: [String, Date] as Vue.PropType<TimeValue | null>,
      default: null
    },
    data: {
      type: [Array, Object] as Vue.PropType<any[] | Record<string, any> | undefined>,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    btnClass: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    persistentHint: {
      type: Boolean,
      default: undefined
    },
    prependIcon: {
      type: [String, Boolean] as Vue.PropType<string | boolean>,
      default: 'event'
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: '00:00'
    },
    mask: {
      type: Boolean,
      default: false
    },
  },

  data(): ComponentData {
    return {
      shown: false,
      date: {
        raw: '',
        formatted: '',
        masked: '',
      },
      input: {
        mask: false,
        disabled: false,
        error: false,
      },
      state: {
        messages: {
          error: []
        }
      }
    }
  },

  watch: {
    value(newVal: TimeValue): void {
      console.log('WATCH', 'TIME_SELECTOR', 'value', 'changes', newVal)
      if (!newVal) return
      const stringValue = typeof newVal === 'string' ? newVal : ''
      this.$set(this.date, 'raw', stringValue)
      this.$set(this.date, 'masked', stringValue)
      // this.date.raw = stringValue
      // this.date.masked = stringValue
    },
    'date.raw': function (newVal: string): void {
      if (!this.validate()) return
      
      let $_data: any = newVal
      if (this.data !== undefined) {
        $_data = {
          data: this.data,
          value: newVal
        }
      }
      this.$emit('dateChange', $_data)
      this.$emit('change', $_data)
    },
    'date.masked': function (newVal: string): void {
      // console.log('WATCH', 'TIME_SELECTOR', 'date.masked', 'newVal', newVal)
      // this.date.raw = this.validate('masked', 'LT') ? this.unformatDate(newVal) : ''
    },
  },

  created(): void {
    if (this.value) {
      const stringValue = typeof this.value === 'string' ? this.value : ''
      this.$set(this.date, 'masked', stringValue)
    } else {
      // this.reset()
    }
  },

  methods: {
    onInput(e: Event): void {
      this.state.messages.error = []
    },

    validate(type?: string, mask?: string): boolean {
      const $_type = type || 'raw'
      const $_mask = mask || 'LT'
      const dateValue = this.date[$_type as keyof DateState]
      const isValid = dateValue && (this as any).moment(dateValue, [$_mask]).isValid()
      return !!(dateValue && dateValue.length == 5 && isValid)
    },

    onBlur(): void {
      // console.log('TIME_SELECTOR', 'onBlur', this.date.masked)
      const d = this.date.masked
      
      if (d.length === 3 || d.length === 2) {
        const hours = parseInt(d.slice(0, 2))
        if (hours > 23) {
          this.state.messages.error.push('Неверное время!')
        } else {
          this.date.masked = d.slice(0, 2) + ':00'
        }
      }
      
      if (this.validate('masked', 'LT')) {
        this.date.raw = this.unformatDate(this.date.masked)
      } else {
        if (this.date.masked && !this.date.raw) {
          this.state.messages.error.push('Неверный формат времени!')
        }
        this.reset()
      }
    },

    formatDate(value: string): string {
      return value
    //   return value ? value.split('-').reverse().join('.') : ''
    },

    unformatDate(value: string): string {
      return value
    //   return value ? value.split('.').reverse().join('-') : ''
    },

    reset(): void {
      setTimeout(() => {
        this.date.raw = ''
        this.date.masked = ''
      }, 10)
      setTimeout(() => {
        this.state.messages.error = []
      }, 2000)
    },
  },
})
</script>
